// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/split_supply_plan_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { SplitSupplyPlanService } from "./split_supply_plan_service_pb";

/**
 * ListOwnSplitSupplyNotices returns the 通 of a 断面 and target date that were
 * created, optionally narrowed to one area.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.ListOwnSplitSupplyNotices
 */
export const listOwnSplitSupplyNotices = SplitSupplyPlanService.method.listOwnSplitSupplyNotices;

/**
 * CreateOwnSplitSupplyNotices creates the 通告値 of every supply point of the
 * area whose contract is a 変動型 with the own side as the 通告値を出す側. A
 * supply point that already has one is left as it is. Rejected with
 * NOTICE_DATE_CLOSED for a past 通, and with NOTICE_TOO_MANY_POINTS (nothing is
 * created) when a 通 would have more than 1000 supply points, the most a save
 * carries.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.CreateOwnSplitSupplyNotices
 */
export const createOwnSplitSupplyNotices = SplitSupplyPlanService.method.createOwnSplitSupplyNotices;

/**
 * GetOwnSplitSupplyNotice returns a 通 with the 48 slots of one delivery date
 * of every supply point, or of every day of the period when no delivery date
 * is asked. The slots are the stored values as they are.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.GetOwnSplitSupplyNotice
 */
export const getOwnSplitSupplyNotice = SplitSupplyPlanService.method.getOwnSplitSupplyNotice;

/**
 * SaveOwnSplitSupplyNoticeValues saves the 48 slots of the given delivery
 * dates (one day, or a whole month) of every supply point of the 通. Rejected with NOTICE_POINTS_CHANGED when the
 * supply points differ from the 通's, and Aborted when a record moved.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.SaveOwnSplitSupplyNoticeValues
 */
export const saveOwnSplitSupplyNoticeValues = SplitSupplyPlanService.method.saveOwnSplitSupplyNoticeValues;

/**
 * DownloadOwnSplitSupplyNoticeXml returns the OCCTO XML (0610 / 0620) of a 通,
 * as one XML or a ZIP of 100-point files. A 月間 通 carries every day of the
 * month. A past 通 can be downloaded.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.DownloadOwnSplitSupplyNoticeXml
 */
export const downloadOwnSplitSupplyNoticeXml = SplitSupplyPlanService.method.downloadOwnSplitSupplyNoticeXml;

/**
 * ListPartnerSplitSupplyNotices returns the 他社の通告値 registrations of a
 * 断面 and target date, optionally narrowed to one area, the latest 登録日時
 * first. There is at most one registration per 断面 x 対象日 x エリア x 他社, and
 * only the asked 断面 and target date are read.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.ListPartnerSplitSupplyNotices
 */
export const listPartnerSplitSupplyNotices = SplitSupplyPlanService.method.listPartnerSplitSupplyNotices;

/**
 * GetPartnerSplitSupplyNoticeFormOptions returns, per area, the companies a 他社の通告値
 * can be registered for on a target date: the other side of the 変動型
 * contracts whose 通告値 that company submits, judged on the date.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.GetPartnerSplitSupplyNoticeFormOptions
 */
export const getPartnerSplitSupplyNoticeFormOptions = SplitSupplyPlanService.method.getPartnerSplitSupplyNoticeFormOptions;

/**
 * CreatePartnerSplitSupplyNotice registers an empty 他社の通告値 for every supply
 * point of the area whose contract is a 変動型 that the chosen company
 * submits the 通告値 of, judged on the delivery date (the first of the month for
 * 月間), and returns its id. Rejected with PARTNER_NOTICE_NO_POINTS (nothing is
 * created) when there is no such point. A past date is accepted. A registration
 * with no value is used for nothing.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.CreatePartnerSplitSupplyNotice
 */
export const createPartnerSplitSupplyNotice = SplitSupplyPlanService.method.createPartnerSplitSupplyNotice;

/**
 * GetPartnerSplitSupplyNotice returns a registration with the 48 slots of one
 * delivery date of every supply point, or of every day of the period when no
 * delivery date is asked. Rejected with PARTNER_NOTICE_NOT_FOUND.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.GetPartnerSplitSupplyNotice
 */
export const getPartnerSplitSupplyNotice = SplitSupplyPlanService.method.getPartnerSplitSupplyNotice;

/**
 * SavePartnerSplitSupplyNoticeValues replaces the 48 slots of the given
 * delivery dates of every supply point of the registration. The registration
 * (登録日時・登録者・登録方法) is unchanged and the last update is recorded. A past
 * registration can be saved. Rejected with PARTNER_NOTICE_POINTS_CHANGED when the supply
 * points differ, and Aborted when the registration moved since it was read.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.SavePartnerSplitSupplyNoticeValues
 */
export const savePartnerSplitSupplyNoticeValues = SplitSupplyPlanService.method.savePartnerSplitSupplyNoticeValues;

/**
 * DeletePartnerSplitSupplyNotice deletes a registration with its supply points
 * and values. The same condition can be registered again afterwards. Rejected with PARTNER_NOTICE_NOT_FOUND when no
 * registration of the organization has the id, NOTICE_DATE_CLOSED when the
 * registration is past (a 翌日 one delivered today or earlier, a 月間 one of this
 * month or earlier) and holds a saved value (an empty one can be deleted whatever
 * its date is), and Aborted when the registration moved since it was read.
 * Either way nothing is deleted.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.DeletePartnerSplitSupplyNotice
 */
export const deletePartnerSplitSupplyNotice = SplitSupplyPlanService.method.deletePartnerSplitSupplyNotice;

/**
 * IssuePartnerSplitSupplyNoticeUploadUrl prepares the import of the 他社の通告値
 * of one file (XML, ZIP or CSV): it returns a one-time upload token and a
 * presigned PUT request the browser sends the file to. The file itself never
 * travels in a request body. A token is good for one import (a preview does
 * not use it up) until it expires.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.IssuePartnerSplitSupplyNoticeUploadUrl
 */
export const issuePartnerSplitSupplyNoticeUploadUrl = SplitSupplyPlanService.method.issuePartnerSplitSupplyNoticeUploadUrl;

/**
 * PreviewPartnerSplitSupplyNoticeImport reads the uploaded files and returns
 * what ImportPartnerSplitSupplyNotices would register, without writing
 * anything: the 通 (new or replacing), the supply points left out, the errors
 * of the files, and a digest of the whole plan. Errors in the files, nothing to
 * import and files over a limit are returned in the response (errors, nothing,
 * too_large), not as RPC errors. Rejected with PARTNER_NOTICE_IMPORT_UPLOAD_EXPIRED
 * when a token cannot be used.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.PreviewPartnerSplitSupplyNoticeImport
 */
export const previewPartnerSplitSupplyNoticeImport = SplitSupplyPlanService.method.previewPartnerSplitSupplyNoticeImport;

/**
 * ImportPartnerSplitSupplyNotices registers the 通 of the uploaded files in one
 * transaction: a new registration where there is none; where one exists, only
 * the supply points the files carry are replaced (their 48 slots whole) and the
 * points the files do not carry stay as they are. The registration date,
 * registrant, channel and file names are kept; only the last update is the
 * import's. The plan is
 * computed again and must equal the digest the preview returned, or nothing is
 * imported (PARTNER_NOTICE_IMPORT_CHANGED). The upload tokens are used up.
 * Rejected with PARTNER_NOTICE_IMPORT_UPLOAD_EXPIRED, PARTNER_NOTICE_IMPORT_INVALID,
 * PARTNER_NOTICE_IMPORT_NOTHING, PARTNER_NOTICE_IMPORT_TOO_LARGE and
 * PARTNER_NOTICE_IMPORT_CHANGED; nothing is written then.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.ImportPartnerSplitSupplyNotices
 */
export const importPartnerSplitSupplyNotices = SplitSupplyPlanService.method.importPartnerSplitSupplyNotices;

/**
 * IssueOwnSplitSupplyNoticeUploadUrl prepares the import of the 自社の通告値 of
 * one file (XML, ZIP or CSV), like IssuePartnerSplitSupplyNoticeUploadUrl. The
 * token is good for the own side's import only.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.IssueOwnSplitSupplyNoticeUploadUrl
 */
export const issueOwnSplitSupplyNoticeUploadUrl = SplitSupplyPlanService.method.issueOwnSplitSupplyNoticeUploadUrl;

/**
 * PreviewOwnSplitSupplyNoticeImport reads the uploaded files and returns what
 * ImportOwnSplitSupplyNotices would write, without writing anything: the 通
 * with the supply points created and overwritten, the supply points left out,
 * the supply points and (supply point, day) pairs with every slot empty that
 * are not imported, the errors of the files and a digest of the whole plan.
 * Errors in the files, nothing to import and files over a limit are returned
 * in the response (errors, nothing, too_large), not as RPC errors. Rejected
 * with OWN_NOTICE_IMPORT_UPLOAD_EXPIRED when a token cannot be used.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.PreviewOwnSplitSupplyNoticeImport
 */
export const previewOwnSplitSupplyNoticeImport = SplitSupplyPlanService.method.previewOwnSplitSupplyNoticeImport;

/**
 * ImportOwnSplitSupplyNotices writes the 自社の通告値 of the uploaded files in
 * one transaction: a supply point without one is created with every day of its
 * period (the values of the files only: a slot the files leave empty and a day
 * they do not carry stay empty, nothing is filled in from the 基本パターン),
 * one that has one gets the days the files carry overwritten and keeps the
 * other days. The plan is computed again and must equal the
 * digest the preview returned, or nothing is written
 * (OWN_NOTICE_IMPORT_CHANGED). The upload tokens are used up. Rejected with
 * OWN_NOTICE_IMPORT_UPLOAD_EXPIRED, _INVALID, _NOTHING, _TOO_LARGE and
 * _CHANGED; nothing is written then.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.ImportOwnSplitSupplyNotices
 */
export const importOwnSplitSupplyNotices = SplitSupplyPlanService.method.importOwnSplitSupplyNotices;

/**
 * DownloadOwnSplitSupplyNoticeCsvTemplate returns the CSV the import reads
 * (the same shape as the CSV for the other company), with a column for every
 * supply point whose 通告値 the own side submits. The cells hold the values the
 * 通告値 has now (a slot without a value stays empty) and, for a supply point
 * without one, the initial values a creation would give (the 基本パターン by
 * day type). Failed when a day type cannot be decided for such a supply point. Rejected with NOTICE_DATE_CLOSED when the period is past
 * and OWN_NOTICE_TEMPLATE_NO_POINTS when there is no supply point. When the
 * supply points are more than one file can carry (1000 columns, the most the
 * import reads in a file), the template is a ZIP of CSVs of at most 1000
 * columns each, which the import reads together.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.DownloadOwnSplitSupplyNoticeCsvTemplate
 */
export const downloadOwnSplitSupplyNoticeCsvTemplate = SplitSupplyPlanService.method.downloadOwnSplitSupplyNoticeCsvTemplate;

/**
 * GetSplitSupplyPlanAvailability returns whether the 分割供給計画 is released.
 * The decision is global (one flag shared by every organization). Every other
 * RPC of this service is rejected with FailedPrecondition while it is false.
 *
 * @generated from rpc bffuser.v1.SplitSupplyPlanService.GetSplitSupplyPlanAvailability
 */
export const getSplitSupplyPlanAvailability = SplitSupplyPlanService.method.getSplitSupplyPlanAvailability;
